module.exports = __webpack_public_path__ + "static/img/school-work@3x.d6eb1650.png";